import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage, FormattedNumber, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { openZipModal } from '@/redux/modules/modal';
import { PaymentMethods } from '@/enums';
import { useAppDispatch } from '@/redux/hooks';
import PaymentMethod from './PaymentMethod';
import Radio from '@liveauctioneers/caterwaul-components/lib/Radio/Radio';
import React from 'react';
import styled from 'styled-components';

type Props = {
    active: boolean;
    amountToPayZip: number;
    currency: string;
    onPaymentMethodChange: (paymentMethod: PaymentMethods) => void;
    paymentMethod: PaymentMethods;
};

const PaymentMethodZip = ({ active, amountToPayZip, currency, onPaymentMethodChange, paymentMethod }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();

    const onZipInfoClick = () => {
        dispatch(openZipModal());
    };

    const display = (
        <div>
            <StyledZipPaymentPlan>
                <LabelStrong>
                    <FormattedMessage
                        id="checkout.payment.zipPaymentsPlan"
                        values={{
                            amount: (
                                <FormattedNumber
                                    currency={currency}
                                    key="checkout-payment-zip-payments-plan-amount"
                                    style="currency"
                                    value={amountToPayZip}
                                />
                            ),
                        }}
                    />
                </LabelStrong>
                <StyledZipLogo src="https://p1.liveauctioneers.com/dist/images/zip-logo.svg" />
                <Info
                    className="inline-flex"
                    data-testid={formatMessage({ id: 'checkout.general.learnMore' })}
                    onClick={onZipInfoClick}
                    size="xs"
                />
            </StyledZipPaymentPlan>
            <BodySecondary color="secondary">
                <FormattedMessage id="checkout.payment.zipInfo" />
            </BodySecondary>
        </div>
    );

    const selected = paymentMethod === PaymentMethods.Zip;

    if (!active) {
        if (selected) {
            return display;
        } else {
            return null;
        }
    }

    return (
        <PaymentMethod
            data-testid="payment-method-zip"
            onClick={() => onPaymentMethodChange(PaymentMethods.Zip)}
            selected={selected}
            subtitle={
                <BodySecondary color="secondary">
                    <FormattedMessage
                        id="checkout.payment.zipPaymentsPlanShort"
                        values={{
                            amount: (
                                <FormattedNumber
                                    currency={currency}
                                    key="checkout-payment-zip-payments-plan-amount"
                                    style="currency"
                                    value={amountToPayZip}
                                />
                            ),
                        }}
                    />
                </BodySecondary>
            }
            title={<StyledZipLogo src="https://p1.liveauctioneers.com/dist/images/zip-logo.svg" />}
        >
            <Radio
                id="zip"
                label={display}
                selectedName="zip"
            />
        </PaymentMethod>
    );
};

export default PaymentMethodZip;

const StyledZipPaymentPlan = styled.div`
    margin-bottom: 4px;
`;

const StyledZipLogo = styled.img`
    margin: 0 4px;
    width: 40px;
`;
